import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const QuickActionCard = ({ icon, title, description, buttonText }) => {
  const navigate = useNavigate();
  const onClick = (type) => {
    if (type === "Neues Formular") {
      navigate("/dashboard/feedback-management", {
        state: { openModal: true },
      });
    } else if (type === "QR Code") {
      navigate("/dashboard/qr-management", { state: { openModal: true } });
    } else if (type === "Berichte") {
      navigate("/dashboard/reports-analytics#reports");
    } else if (type === "Statistiken") {
      navigate("/dashboard/reports-analytics#stats");
    } else if (type === "Einstellungen") {
      navigate("/dashboard/settings");
    }
  };

  return (
    <div className="mb-4 last:mb-0">
      <div className="flex flex-col md:flex-row md:items-center gap-4 p-4 bg-white rounded-lg hover:bg-gray-50 transition-colors">
        <div className="text-2xl text-blue-500">{icon}</div>
        <div className="flex-grow">
          <h3 className="text-lg font-medium mb-1">{title}</h3>
          <p className="text-gray-600 text-sm">{description}</p>
        </div>
        <Button
          type="primary"
          className="bg-orange-500 !hover:bg-orange-600 md:w-[30%] w-full"
          onClick={() => onClick(title)}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default QuickActionCard;
